import isObject from 'lodash/isObject';
import * as T from 'prop-types';
import {applyAutoFilter, ReduxList} from '../../../_libs/redux-observable-list';
import {buildUserChannelSyncNotifier} from '../../../auth/utils/redux-lists';
import {BASE_REDUX_LIST_OPTIONS} from '../../../config/redux-list/index';
import {sortByProperty} from '../../../core-utilities/filters/filterUtils';
import {applyDefaultReduxListComponentOptions} from '../../../core-utilities/redux/ReduxListContainer';
import {SYNC_PATH} from '../../../core-utilities/rx-utils/index';
import {getNavOrganizations} from '../reducers/state';
import {logger} from './logger';
import {NAV_ORGANIZATION_LIST_PREFIX} from './state';


const parentPath = 'users';
const resourcePath = `organizations`;
const childPath = 'organizations';

const matchesAutoFilter = applyAutoFilter(['name'], 1);

export const reduxList = new ReduxList({
  ...BASE_REDUX_LIST_OPTIONS,
  prefix: NAV_ORGANIZATION_LIST_PREFIX,
  getState: getNavOrganizations,
  pageSize: 100,
  hasParentId: true,
  useDelete: false,
  useFiltering: true,
  useAutoFilter: true,
  useFilterOptions: false,
  useSortOptions: false,
  applySortOptions,
  defaultSortOptions: {},
  isVisible,
  syncNotifier: buildUserChannelSyncNotifier(childPath),
  listPath: parentId => `${parentPath}/${parentId}/${childPath}`,
  listSyncPath: parentId => `${parentPath}/${parentId}/${childPath}/${SYNC_PATH}`,
  logger,

  // cacheOptions: {
  //   localForage: asyncStorage,
  //   key: targetOptions.cacheName,
  // },
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options);

function isVisible(item, filterData) {
  if (!isObject(item)) return false;
  if (!matchesAutoFilter(item, filterData.filter)) return false;
}

export function applySortOptions(list) {
  return list.sort(sortByProperty('name', true, true));
}

// TODO: move appropriately and fill in data
const avatarType = T.shape({
  url: T.string,
});

export const orgModelShape = T.shape({
  name: T.string,
  description: T.string,
  role: T.string,
  poc: T.shape({
    name: T.string,
    avatar: avatarType,
  }),
  avc: T.number,
  avatar: avatarType,
  permissions: T.shape({
    organization_access_view: T.bool,
  }),
});

/*
List Model:
{
  organizations: {
    name
    description
    role

    poc: Person

    avatar: Avatar

    permissions: {
      organization_access_view
    }
  }
}
 */



// WEBPACK FOOTER //
// ./src/js/app/navigation/redux/organizations.js